import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpCommonActions } from "../../actions/mp-common.actions";
import { OnOrbitCountryState } from "../../models/mp-common/on-orbit-country.state";

const initialState: OnOrbitCountryState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.onOrbitCountry.api, (state) => ({ ...state, loading: true })),
	on(MpCommonActions.onOrbitCountry.success, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(MpCommonActions.onOrbitCountry.fail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function onOrbitCountryReducer(
	state: OnOrbitCountryState | undefined,
	action: Action
): OnOrbitCountryState {
	return reducer(state, action);
}
